import { isNotEmpty } from 'ramda-adjunct';
import { WidgetConfig } from 'components-fabric/_types';
import { ScreenProps } from '@components-common/types';
import { assocPath, find, map } from 'ramda';
import { WidgetQuickActions } from '../../../components-common/widgets';

export const mapWidgets = (
  cfg: any,
  context: Partial<ScreenProps>,
  type?: string
) => {
  if (!cfg?.widgets) return [];
  const result = map((x) => mapWidget(x, context.id), cfg.widgets);
  return result;
};

export const mapWidget = (widgetConfig: WidgetConfig, parentId?: string) => {
  const {
    Component = WidgetQuickActions,
    id,
    type = 'custom',
    ...rest
  } = widgetConfig;
  let result = {
    id: `wgt_${find(isNotEmpty, [id, parentId, 'NOT_SET'])}`,
    Component,
    type,
    cat: 'widget',
    props: rest ? { ...rest } : undefined,
  };
  if (rest) {
    result = assocPath(['props'], { ...rest }, result);
  }
  return result;
};
